module.exports = __webpack_public_path__ + "static/OSXKWY0-d57e0f4c7b7c21b492dc9ab7a2e0f853.png";